import { Component, OnInit, ElementRef} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';
import { NavigationExtras } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { APIService } from '../../providers/api.service';
import { DetailsService } from '../../providers/details.service';
import { MatDialog } from '@angular/material/dialog';
import * as moment from 'moment-timezone';
import { AnalyticsManagerService } from '../../providers/analytics-manager.service';
import * as jwt_decode from 'jwt-decode';
import { DomSanitizer} from '@angular/platform-browser';

declare var $: any;
declare var AppleID: any;

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.css'],
  providers: [APIService]
})

export class SigninComponent implements OnInit {
  youtubevideo:any;
  foregroundUrl:any;
  layoutRadioCheckModel = "sideBySide";
  foregroundRadioCheckModel = "video";
  loginBackgroundImage: any;
  decoded: any;
  fbcode: any;
  gcode: any;
  avail: boolean = false;
  notAvail: boolean = false;
  isNewUser: any;
  uservalue: any;
  public userLoginAdmin: any = {
    userName: null,
    password: null
  };
  emaildisable;
  createAcc = {
    email: null
  }

  public link = null
  public googleLink = null
  public nameValidate: boolean = false
  public passWordValidate: boolean = false
  public errormsg: any = ''
  public token: any
  public forgettoken: any
  public invitetoken: any
  public inviteemail: any
  public tcode: any
  public captchaResponse = null
  public routeParams: any;
  public siteKey;
  public currentLat: any;
  public currentLong: any;

  public year = new Date().getFullYear();
  public ID = "";
  public self = {
    gcode: "",
    fbcode: "",
    tcode: "",
    refercode: "",
    hotmailcode: "",
    yahoocode: "",
    social: ""
  };
  public releaseOS = 105;
  public versionNo = '1.0.0';
  public urlParams: any;

  appleresponse: any;

  showEmail: boolean;
  resendEmail: any;
  msg: any;
  keepMe: boolean = false;
  siteURL:any;
  menuview:boolean =true;
 
  loginbg:any;
  orgid:any;
  videoplay:boolean = false;
  constructor(
    private APIService: APIService,
    public localStorageService: LocalStorageService,
    private detailsService: DetailsService,
    private router: Router,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private activatedRoute: ActivatedRoute,
    public analyticsManager: AnalyticsManagerService,
    private domSanitizer: DomSanitizer,
    private el: ElementRef
  ) {
    if (this.localStorageService.get('userName')) {
      this.userLoginAdmin.userName = this.localStorageService.get('userName');
      this.userLoginAdmin.password = '';
      this.localStorageService.remove('userName');
    } else {
      this.userLoginAdmin.userName = '';
      this.userLoginAdmin.password = '';
    }

    AppleID.auth.init({
      clientId: 'com.statementgames.website',
      scope: 'name email',
      redirectURI: 'https://www.statementgames.com/#/welcome/about',
      response_type: 'code',
      state: ''
    });

  }

  validatelogin = function (user) {
    if (user) {
      if (user.userName == '' || user.userName == undefined && user.password == '' || user.password == undefined) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }


  ngAfterViewInit() {
    const innerDiv = this.el.nativeElement.querySelector('#appleid-signin > div');
    if (innerDiv) {
      innerDiv.style.margin = '0 auto';
      innerDiv.style.width = '81%';
      innerDiv.style.minWidth = '81%';
    }
  }

  checkPrivateContest = function () {
    var self = this
    var email = self.localStorageService.get('email');
    var token = self.localStorageService.get('token');
    var isNew = self.localStorageService.get('isNewUser');
    if (isNew && email == undefined && token == undefined) {
      this.router.navigate(['/landing/signup']);
    } else if (email == undefined && token == undefined) {
      // $state.go('login.sigin'); Need to change
      this.router.navigate(['/landing/signin']);
    } else {
      // $state.go('user.lobby'); Need to change
      localStorage.setItem('isFromSignin', 'true');
      self.localStorageService.add('reloadPage', true);
      this.router.navigate(['/user/lobby']);
      // setTimeout(() => {

      // }, 2000);
    }
  }

  login = function (user) {

    var self = this
    self.uservalue = user.userName;
    if (user.userName == '' || user.userName == null || user.userName == undefined) {
      self.nameValidate = true;
    } else {
      self.nameValidate = false;
    }
    if (user.password == '' || user.password == null || user.password == undefined) {
      self.passWordValidate = true;
    } else {
      self.passWordValidate = false;
    }

    user.releaseOS = 105;
    user.versionNo = '1.0.0';

    // return $validator.validate($scope, 'userLoginAdmin').success(function() {
    if (self.nameValidate == false && self.passWordValidate == false) {
      // user.gRecaptchaResponse = self.captchaResponse;
      $('.loder').show();
      self.APIService.doApiCall(function (data) {
        // /console.log(data)
        $('.loder').hide();
        if (data.StatusCode == 'SG001') {
          self.localStorageService.add('organizationId', data.organizationId);
          self.localStorageService.add('email', data.email);
          self.localStorageService.add('userId', data.userid);
          self.localStorageService.add('userName', data.userName);
          self.localStorageService.add('token', data.accessToken);
          self.localStorageService.add('token', data.accessToken);

          localStorage.removeItem('Referal-Token');

          self.joinContestId = self.localStorageService.get('joinContestId');
          self.APIService.doApiCall(function (data) {
            self.localStorageService.add('roleId', data.Data.roleId);
            if (data.Data.roleId === self.detailsService.loginSuperAdmin) {
              self.localStorageService.add('loginas', "superadmin");
              self.localStorageService.add('admin_email',  self.localStorageService.get('email'));
            }
            else{
              self.localStorageService.add('loginas', undefined);

            }
            if (data.Data.roleId === self.detailsService.sgAdmin || data.Data.roleId === self.detailsService.loginSuperAdmin || data.Data.roleId === self.detailsService.clientAdmin) {
              // $window.location.href = "admin.html";
              // $state.go('dashboard/home'); Need to change
              self.localStorageService.add('reloadPage', true);
              self.router.navigate(['/dashboard/home']);
            } else if (data.Data.roleId === self.detailsService.loginUser) {
              // window.location.href = "lobby.html";
              // window.location.href = "user-dashborad.component.html";
              // self.router.navigate(['/user/']);
              // var invitecontest = localStorage.getItem("inviteContestId");
              self.analyticsManager.setUserId(data.Data.userId)
              var userProperties = {
                'gender': data.Data.gender !== null ? true : false,
                'phone number': data.Data.mobileNumber !== null ? true : false,
                'address': data.Data.address !== null ? true : false,
                'coin balance': data.Data.coinBalance,
                'signup type': data.Data.signupType == null ? 'None' : data.Data.signupType,
                'last activity date': moment(new Date()).format('DD/MM/YYYY'),
                'account created date': moment(new Date(data.Data.recInsDt)).format('DD/MM/YYYY')
              }
              self.analyticsManager.setUserProperties(userProperties);
              var loginEvents = {
                'type': data.Data.signupType,
                'Keep me logged in': self.localStorageService.get('KeepMeloggedIn')
              };

              self.localStorageService.add('isPushNotification', data.Data.isPushNotification)

              self.analyticsManager.logEvent('Login User', loginEvents);
              if (self.activatedRoute.queryParams.value.contestid || self.joinContestId) {
                self.localStorageService.add('isPrivateContest', 'private');
                self.checkPrivateContest();
              }
              else {
                var compaignUrl = self.localStorageService.get('compaignUrl');
                var url = window.location.origin + '/';
                // if (self.token) {
                //   setTimeout(() => {
                //     self.localStorageService.add('reloadPage', true);
                //     if (compaignUrl) {
                //       // window.location.href = url + "#/landing/signup/success?utm_source" + compaignUrl;
                //       self.router.navigate(['/landing/signup/success'], { queryParams: { utm_source: compaignUrl } });
                //     }
                //     else {
                //       // window.location.href = url + "#/landing/signup/success";
                //       self.router.navigate(['/landing/signup/success']);
                //     }
                //   }, 1000);
                // }
                // else {
                //   setTimeout(() => {
                //     self.localStorageService.add('reloadPage', true);
                //     if (compaignUrl) {
                //       // window.location.href = url + "#/landing/signin/success" + compaignUrl;
                //       self.router.navigate(['/landing/signin/success' + compaignUrl]);
                //     }
                //     else {
                //       // window.location.href = url + "#/landing/signin/success";
                //       self.router.navigate(['/landing/signin/success']);
                //     }
                //   }, 1000);
                // }            
                  self.localStorageService.add('reloadPage', true);
                  if (compaignUrl) {
                    // window.location.href = self.localStorageService.get('newUrl') + "#/user/lobby";
                    window.location.href = self.localStorageService.get('newUrl') + '/user/lobby';
                  }
                  else {
                    // window.location.href = url + "#/user/lobby";
                    self.router.navigate(['/user/lobby']);
                  }
              }
            }
          }, 'api/profile/userinfo?email=' + data.email, 'GET', null, null);
        }
         else {
          // self.recaptchaRef.reset();
          self.errormsg = data.Message;
          if(self.errormsg == ' SG103'){
            self.errormsg = "Incorrect Username or Email";
          }
          if (data.StatusCode == 'SG112') {
            user.password = '';
          } else {
            user.userName = '';
            user.password = '';
          }
          setTimeout(() => {
            self.errormsg = '';
          }, 5000);
        }

        if (data.StatusCode == 'SG181') {
          const navigationExtras: NavigationExtras = {
            state: {
              'emailId': self.uservalue
            }
          };

          setTimeout(() => {
            self.router.navigateByUrl('/otpreceive', navigationExtras);
          }, 5000);
        }
        // console.log('user', user);
      }, 'api/user/auth?siteUrl=' + self.siteURL, 'POST', user, null);
    }
  };

  async ngOnInit() {
    
    this.siteURL = this.localStorageService.get('siteUrl');
    if (this.siteURL == null) {
      const subdomain = window.location.hostname.split('.')[0];
      this.siteURL = `https://${subdomain}.statementgames.com`;
    }
   // this.generateMetaTags();

    this.APIService.doApiCall((data:any) => {
       if (data.StatusCode == "SG001") {
        this.orgid = data.Data.organizationId;
        if (this.orgid == 1) {
         this.menuview = true;
         this.loginbg = '../../../../assets/img/register-bg.jpg';
         }
        else {
         this.menuview = true;
         }
        this.foregroundUrl = data.Data.foregroundImage;
        this.layoutRadioCheckModel = data.Data.layout?data.Data.layout:'sideBySide';
        this.foregroundRadioCheckModel = data.Data.foregroundToUse === 'foreground' ? "foregroundImage" : "video"; 
        this.loginBackgroundImage = data.Data.loginBackgroundImage;
         if(data.Data.videoUrl != null){
         this.youtubevideo = data.Data.videoUrl;
         if(!data.Data.videoUrl && data.Data.youtubeLoginUrl){
          this.youtubevideo = data.Data.youtubeLoginUrl;
         }
         this.localStorageService.add('videoUrl', this.youtubevideo);
         if(this.youtubevideo !=  undefined && this.youtubevideo != '' && this.youtubevideo != null && this.youtubevideo != 'null'){
          let array2 = this.youtubevideo.split("?v=");
          if(array2.length == 1){
            this.youtubevideo = array2[0]
          }
          if(array2.length > 1){
            if(array2[1].includes('&')){
              let array3 = array2[1].split("&");
              this.youtubevideo = "https://www.youtube.com/embed/" + array3[0]
            }
             else{
              this.youtubevideo = "https://www.youtube.com/embed/" + array2[1]
             }
          }
         
           console.log(this.youtubevideo);
           this.youtubevideo = this.domSanitizer.bypassSecurityTrustResourceUrl(this.youtubevideo);
         }
        }
       }
       else{
        this.youtubevideo = null;
       }

     }, 'api/organization/listbySiteUrl?siteUrl=' + this.siteURL, 'GET', null, null);
    this.loginbg = this.localStorageService.get('login_bg');
    this.loginbg =  this.loginbg != null ? this.loginbg : '../../../../assets/img/register-bg.jpg';
    
   // console.log(this.siteURL)
    // this.siteURL = this.siteURL.slice(0, -16)
    // console.log(this.siteURL)
    //Fetch the URL parameters from the variable
    this.activatedRoute.queryParams
      .subscribe(params => {
        this.urlParams = params;
        //Check for google signin code
        if (params.state !== undefined) {
          if(params.code !== undefined && params.state.includes("google")){
            this.self.gcode = params.code;
            this.self.social = "Google";
          }
          else if(params.code !== undefined){
            this.self.hotmailcode = params.code;
            localStorage.setItem('Hotmail-Code', params.code);
            this.self.social = "Hotmail";
          }
        } else {
          if(params.code !== undefined && params.code.length > 50) {
            this.self.fbcode = params.code;
            this.self.social = "Facebook"
          } else if(params.code !== undefined && params.code.length < 50) {
            this.self.social = "Yahoo";
            this.self.yahoocode = params.code;
            localStorage.setItem('Yahoo-Code', this.self.yahoocode);
          } else if(window.location.hash) {
            this.self.refercode= this.getHashValue("access_token");
            this.self.social = "Referer";
            localStorage.setItem('Referal-Token', this.self.refercode);
          }
        }

        //case statement for the social login
        switch (this.self.social) {
          case 'Google':
            var self = this;
            self.APIService.doApiCall(function (data) {
              let successstatus = true;
              if (data.StatusCode == "SG001") {
                var registerEvent = {
                  type: "google",
                  success: true
                }
                self.localStorageService.add('email', data.email);
                self.localStorageService.add('userId', data.userid);
                self.localStorageService.add('userName', data.userName);
                self.localStorageService.add('token', data.accessToken);
                localStorage.removeItem('Referal-Token');
                self.processLogin(data);
              }
            }, 'api/google/login?code=' + this.self.gcode + '&releaseOS=' + this.releaseOS + '&versionNo=' + this.versionNo, 'GET', null, null)

            break;
          case 'Facebook':
            var self = this;
            self.APIService.doApiCall(function (data) {
              let successstatus = true;
              if (data.StatusCode == "SG001") {
                var registerEvent = {
                  type: "facebook",
                  success: true
                }
                self.localStorageService.add('email', data.email);
                self.localStorageService.add('userId', data.userid);
                self.localStorageService.add('userName', data.userName);
                self.localStorageService.add('token', data.accessToken);
                localStorage.removeItem('Referal-Token');
                self.processLogin(data);
              }
            }, 'api/facebook/login?code=' + this.self.fbcode + '&releaseOS=' + this.releaseOS + '&versionNo=' + this.versionNo, 'GET', null, null)
            break;
          case 'Yahoo':
            window.location.href = "/user/refer-a-friend";
            break;
          case 'Hotmail':
            window.location.href = "/user/refer-a-friend";
            break;
          case 'Referer':
            window.location.href = "/user/refer-a-friend";
            break;
          default:
            break;
        }
      });


    try {
      const data = await AppleID.auth.init({
        clientId: 'com.statementgames.website',
        scope: 'name email',
        redirectURI: window.location.href,
        response_type: 'code',
        usePopup: true,
        state: ''
      });
      // console.log('window.location.href', window.location.href);
      // console.log('aple login data', data);
    } catch (error) {
      // console.log('aple login data', error);
    }

    // tslint:disable-next-line:max-line-length
    document.addEventListener('AppleIDSignInOnSuccess', (data: any) => {
      // console.log('AppleIDSignInOnSuccess', data);
      this.appleresponse = data.detail;
      // console.log('this.appleresponse detail', this.appleresponse);
      const author = data.detail.authorization;
      // console.log('this.appleresponse detail', author);
      const user = data.detail.user;
      const jwtdecoded = jwt_decode(author.id_token);
      // console.log('jwt.payload', jwtdecoded);

      let email: any;
      let firstname: any;
      let lastname: any;

      if (user) {
        // console.log('inside if user');
        email = user.email;
        firstname = user.name.firstName;
        lastname = user.name.lastName;
      } else {
        // console.log('inside else user');
        email = '';
        firstname = '';
        lastname = '';
      }

      this.loginwithapple(jwtdecoded.sub, email, firstname, lastname);
      // handle successful response
    });

    // Listen for authorization failures
    document.addEventListener('AppleIDSignInOnFailure', (error) => {
      // console.log('AppleIDSignInOnFailure', error);
      // handle error.
    });

    var self = this;
    if (this.urlParams.utm_source !== undefined) {
      // console.log(this.urlParams);
    }

    //privatecontestcheck
    if ((self.activatedRoute && self.activatedRoute.queryParams)) {
      self.activatedRoute.queryParams.subscribe(params => {
        self.routeParams = params;
        self.token = self.routeParams && self.routeParams.token ? self.routeParams.token : null; //create activetoken
        self.forgettoken = self.routeParams && self.routeParams.forgettoken ? self.routeParams.forgettoken : ''; //forgetpasswordtoken
        self.invitetoken = self.routeParams && self.routeParams.invite ? self.routeParams.invite : '';
        self.localStorageService.add('invitetoken', self.invitetoken)
        self.inviteemail = self.routeParams && self.routeParams.email ? self.routeParams.email : '';
        self.tcode = self.routeParams && self.routeParams.oauth_verifier ? self.routeParams.oauth_verifier : '';
        if (self.routeParams.state) {
          self.gcode = self.routeParams.code === undefined ? '' : self.routeParams.code;
        } else {
          self.fbcode = self.routeParams.code === undefined ? '' : self.routeParams.code;
        }
        if (self.routeParams.contestid) {
          self.decoded = self.routeParams.contestid.split(' ').join('+');
        }
        // if(localStorage.getItem('inviteContestId')) {
        //   self.decoded = localStorage.getItem('inviteContestId');
        //   self.localStorageService.add('decoded',self.decoded);
        // }
        if (self.routeParams.professionalGameId) {
          var email = self.localStorageService.get('email');
          var token = self.localStorageService.get('token');
          if (email == undefined && token == undefined) {
            self.router.navigate(['/landing/signin']);

          } else {
            let tId: NavigationExtras = {
              queryParams: {
                'tId': self.routeParams.professionalGameId
              }
            };
            self.router.navigate(['/user/makeStatement'], tId);
          }
        }
        if (self.decoded) {
          var contestid = self.routeParams.contestid === undefined ? '' : atob(decodeURIComponent(self.decoded)).split('id')[1];

        }

        if (self.invitetoken != undefined && self.invitetoken != '') {

          if (self.inviteemail) {
            self.createAcc.email = self.inviteemail;
            self.emaildisable = true;
          } else {
            self.emaildisable = false;
          }
          self.router.navigate(['/landing/signup']);
          self.APIService.doApiCall(function (data) {
            if (data.StatusCode != 'SG004') {
              self.toastr.error(data.Message);
              setTimeout(function () {
                self.router.navigate(['/landing/signup']);
              }, 2000);
            }

          }, 'api/user/token/verify/' + self.invitetoken, 'GET', null, null);
        }

        if (self.token != '' && self.token != null) {
          // if (self.token.split('_')) {

          // }
          // if (self.token.match('_')) {
          //   var token_value = self.token.split('_');
          //   self.token = token_value[0];
          //   localStorage.setItem("inviteContestId", btoa('id'+ token_value[1]));
          // }
          // $('.loder').show();
          $('.signin-div').hide();
          $('.please-wait').show();

          self.APIService.doApiCall(function (data) {
            // $('.loder').hide();
            $('.please-wait').hide();
            $('.signin-div').show();
            if (data.StatusCode == 'SG002') {
              self.router.navigate(['landing/email-success']);
            } else if (data.StatusCode == 'SG121') {
              self.router.navigate(['landing/signup-verified']);
            } else {
              if (data.StatusCode == 'SG114') {
                self.showEmail = true;
                self.resendEmail = data.Data;
                localStorage.setItem('showEmail', 'true');
                localStorage.setItem('resendEmail', self.resendEmail);
              }
              else {
                self.showEmail = false;
                localStorage.setItem('showEmail', 'false');
              }
              self.msg = data.Message;
              localStorage.setItem('msg', self.msg)
              self.router.navigate(['landing/signup-error']);
            }

          }, 'api/user/activate/' + self.token, 'PUT', null, null);
        }



        if (contestid) {
          self.localStorageService.add('contestid', contestid);
          self.localStorageService.add('decoded', self.decoded);
          self.checkPrivateContest();
        }


      });

      //check token for forgetmail/password
      if (self.forgettoken != '') {
        self.APIService.doApiCall(function (data) {
          if (data.StatusCode == 'SG004') {
            localStorage.setItem('forgettoken', self.forgettoken);
            self.router.navigate(['landing/setPassword']);
            // $state.go('login.setpassword');
          } else if (data.StatusCode == 'SG121') {
            // $state.go('login.verified');
            self.router.navigate(['/landing/signup-verified']);
          }
        }, 'api/user/token/verify/' + self.forgettoken, 'GET', null, null);

      }


    }
    self.APIService.doApiCall(function (data) {
      self.link = data.Data
    }, 'api/facebook/url', 'GET', null, null)

    self.APIService.doApiCall(function (data) {
      self.googleLink = data.Data
    }, 'api/google/url', 'GET', null, null)

    let mailId = localStorage.getItem('emailid');
    localStorage.removeItem('emailid')
    if (mailId) {
      self.userLoginAdmin.userName = atob(mailId);
      // localStorage.removeItem('emailId');
    }


    //video
    // var interval = setInterval(function () {
    //   if ($('.video-play') && $('.video-play').length > 0) {
    //     clearInterval(interval)
    //     $('.video-play').click(function () {

    //       self.analyticsManager.logEvent('View Video', { url: window.location.href })
    //       $(this).hide();
    //       if ($('#t-video').length == 0) {
    //         $(this).parent().append
    //           ('<iframe width="580" height="330" class="frme-wdth" frameborder="0" wmode="Opaque" allowfullscreen="" src="https://www.youtube.com/embed/Izy3jkCqGXo?wmode=transparent?rel=0&autoplay=0" id="t-video" style="margin: 15px auto;width: 550px;"></iframe>')
    //         $('#t-video')[0].src = 'https://www.youtube.com/embed/Izy3jkCqGXo?rel=0&autoplay=1&loop=1&playlist=Izy3jkCqGXo';
    //         $('#t-video').show();
    //       }
    //     });
    //     $('.testimonials-carousel').owlCarousel({
    //       autoplay: true,
    //       dots: true,
    //       loop: true,
    //       responsive: {
    //         0: {
    //           items: 1
    //         },
    //         768: {
    //           items: 2
    //         },
    //         900: {
    //           items: 3
    //         }
    //       }
    //     });

    //     // Clients carousel (uses the Owl Carousel library)
    //     $('.clients-carousel').owlCarousel({
    //       autoplay: true,
    //       dots: true,
    //       loop: true,
    //       responsive: {
    //         0: {
    //           items: 2
    //         },
    //         768: {
    //           items: 4
    //         },
    //         900: {
    //           items: 5
    //         }
    //       }
    //     });
    //   }

    // }, 1000);
  }

  clearerrormsg = function () {
    var self = this;
    self.avail = true;
    self.notAvail = true;
    self.errormsg = ''
    self.createAcc = {};
  };

  loggedIn(keepMe) {
    var self = this;
    self.keepMe = keepMe;
    self.localStorageService.add('KeepMeloggedIn', keepMe);
  }

  loginwithapple(code, email, firstname, lastname) {
    var self = this;
    var releaseOS = 105;
    var versionNo = '1.0.0';
    $('.loder').show();
    self.APIService.doApiCall(function (info) {

      // console.log('apple response', info);
      $('.loder').hide();

      if (info.StatusCode == 'SG001') {
        self.localStorageService.add('email', info.email);
        self.localStorageService.add('userId', info.userid);
        self.localStorageService.add('userName', info.userName);
        self.localStorageService.add('token', info.accessToken);

        self.APIService.doApiCall(function (data) {


          if (data.Data.roleId === self.detailsService.sgAdmin || data.Data.roleId === self.detailsService.loginSuperAdmin) {
            // $window.location.href = "admin.html";
            // $state.go('dashboard/home'); Need to change
            self.localStorageService.add('reloadPage', true);
            self.router.navigate(['/dashboard/home']);
          } else if (data.Data.roleId === self.detailsService.loginUser) {
            // window.location.href = "lobby.html";
            // window.location.href = "user-dashborad.component.html";
            // self.router.navigate(['/user/']);
            // var invitecontest = localStorage.getItem("inviteContestId");
            self.analyticsManager.setUserId(data.Data.userId)
            var userProperties = {
              'gender': data.Data.gender !== null ? true : false,
              'phone number': data.Data.mobileNumber !== null ? true : false,
              'address': data.Data.address !== null ? true : false,
              'coin balance': data.Data.coinBalance,
              'signup type': data.Data.signupType == null ? 'None' : data.Data.signupType,
              'last activity date': moment(new Date()).format('DD/MM/YYYY'),
              'account created date': moment(new Date(data.Data.recInsDt)).format('DD/MM/YYYY')
            }
            self.analyticsManager.setUserProperties(userProperties);
            var loginEvents = {
              'type': data.Data.signupType,
              'Keep me logged in': self.localStorageService.get('KeepMeloggedIn')
            };

            self.localStorageService.add('isPushNotification', data.Data.isPushNotification);
            self.analyticsManager.logEvent('Login User', loginEvents);
            self.router.navigate(['/user/lobby']);
          }
        }, 'api/profile/userinfo?email=' + info.email, 'GET', null, null);
      }

      // tslint:disable-next-line:max-line-length
    }, 'api/apple/loginMobile?code=' + code + '&email=' + email + '&firstName=' + firstname + '&lastName= ' + lastname + '&releaseOS=' + releaseOS + '&versionNo=' + versionNo, 'GET', null, null);
  }

  //Generic Process for login
  processLogin = function (data) {
    var self = this;
    var headers = {
      'Access-Token': data.accessToken,
      'Content-Type': "application/json"
    }

    self.APIService.doApiCall(function (result) {
      if (result.Data.roleId === 1 || result.Data.roleId === 3) {
        self.router.navigate(['/dashboard/home']);
      } else if (result.Data.roleId === 2) {

        var contestid = localStorage.getItem('contestid');
        if (contestid) {
          self.checkPrivateContest();
        } else {
          var compaignUrl = localStorage.getItem('compaignUrl');
          if (result.userType == 'newUser') {
            if (compaignUrl)
              window.location.href = "/landing/signup/success" + compaignUrl;
            else
              window.location.href = "/landing/signup/success";
          }
          else {
            if (compaignUrl)
              window.location.href = "/landing/signin/success" + compaignUrl;
            else
              window.location.href = "/landing/signin/success";
          }
          if (compaignUrl) {
            window.location.href = localStorage.getItem('newUrl') + "/user/lobby";
          }
          else {
            self.router.navigate(['/user/lobby']);
          }
        }
      }
    }, 'api/profile/userinfo?email=' + data.email, 'GET', null, headers);
  }

  getHashValue = function(key) {
    var matches = location.hash.match(new RegExp(key+'=([^&]*)'));
    return matches ? matches[1] : null;
  }
  video(){
    this.videoplay = true;
  }
  // generateMetaTags(): void {   
  //   const metaTags = [
  //     { title:'Statement Games', 
  //       description: 'Taking fantasy sports to the next level', 
  //       name: 'Statement Games', 
  //       content: 'Taking fantasy sports to the next level',
  //       site_name: "Statement Games",
  //       url: "https://www.statementgames.com/",      
  //       image: 'https://qaappgames.statementgames.com/assets/img/SG-logo-350px.png',
  //       width: '64px',
  //       height: '64px'
  //     }
  //   ];
  //   metaTags.forEach((tag) => {
  //     const element = this.meta.getTag(`name='${tag.name}'`);
  //     console.log("element", element)
  //     if (element) {        
  //     } else {
  //       this.meta.updateTag({ property: 'title', content: tag.title});
  //       this.meta.updateTag({ property: 'description', content: tag.description });
  //       this.meta.updateTag({ property: 'og:title', content: tag.name});
  //       this.meta.updateTag({ property: 'og:description', content: tag.content });
  //       this.meta.updateTag({ property: 'og:site_name', content: tag.site_name });       
  //       this.meta.updateTag({ property: 'og:url', content: tag.url });
  //       this.meta.updateTag({ property: 'og:image', content: tag.image });
  //       this.meta.updateTag({ property: 'og:image:width', content: tag.width });
  //       this.meta.updateTag({ property: 'og:image:height', content: tag.height });
  //       // console.log("insideelse")
  //       // If the meta tag doesn't exist, create a new one
  //       // const meta = this.renderer.createElement('meta');
  //       // this.renderer.setAttribute(meta, 'name', tag.name);
  //       // this.renderer.setAttribute(meta, 'content', tag.content);
  //       // this.renderer.appendChild(document.head, meta);
  //     }
  //   });
  // }
  
}
